import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import ScorePage from 'components/Admin/Score/ScorePage';
import RegistUserPage from 'components/Admin/RegistUser/RegistUserPage';

const Admin: FC = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/score`}>
        <ScorePage />
      </Route>
      <Route path={`${match.path}/registuser`}>
        <RegistUserPage />
      </Route>
    </Switch>
  );
};

export default Admin;
